import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';
import { formatRelative, formatViews } from '@/utils/format';

export default function Hero() {
  const featured = articles[0];
  const hotList = [...articles].sort((a, b) => b.hot - a.hot).slice(0, 5);
  const tickerItems = [...articles].slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="flex items-center gap-4 border-b border-background-200 bg-background-50">
        <div className="flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-2.5 text-background-50 md:px-6">
          <span className="h-2 w-2 rounded-full bg-background-50 animate-pulse-dot"></span>
          <span className="whitespace-nowrap font-label text-xs font-semibold tracking-wide">最新进展</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="flex w-max animate-marquee items-center gap-8">
            {[...tickerItems, ...tickerItems].map((item, index) => (
              <Link
                key={`${item.id}-${index}`}
                to={`/article/${item.id}`}
                className="flex items-center gap-2 whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-flashlight-fill text-accent-500"></i>
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 py-8 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium text-primary-700">
              <i className="ri-live-line text-sm"></i>
              现场直击
            </span>
            <h1 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
              爆料吃瓜现场直击
              <span className="mt-2 block text-xl font-semibold text-primary-600 md:text-3xl">
                全程围观最新进展，看热闹不迷路
              </span>
            </h1>
            <p className="mt-4 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
              这里有爆料吃瓜现场的一手整理，实时更新最新进展，围观明星网红翻车实况。我们把零散消息按时间线拼好，你想知道的瓜都在这里，吃瓜群众速来围观。
            </p>

            <Link
              to={`/article/${featured.id}`}
              className="group mt-7 block overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="relative h-52 w-full overflow-hidden md:h-full md:min-h-[260px]">
                  <img
                    src={featured.cover}
                    alt={featured.title}
                    title={`${featured.title} - 爆料吃瓜现场`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-col p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-sm bg-accent-100 px-2 py-0.5 font-label text-xs font-medium text-accent-900">
                      今日最热
                    </span>
                    <span className="font-label text-xs text-foreground-500">
                      {featured.categoryName} · {formatRelative(featured.date)}
                    </span>
                  </div>
                  <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-2xl">
                    {featured.title}
                  </h2>
                  <p className="mt-3 line-clamp-3 font-body text-sm leading-relaxed text-foreground-600">
                    {featured.excerpt}
                  </p>
                  <div className="mt-auto flex items-center justify-between pt-5 font-label text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-sm"></i>
                      {formatViews(featured.views)} 围观
                    </span>
                    <span className="inline-flex items-center gap-1 font-medium text-primary-600">
                      阅读全文
                      <i className="ri-arrow-right-line text-base"></i>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-center justify-between border-b border-background-200 pb-3">
              <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-fill text-primary-500"></i>
                吃瓜热榜
              </h2>
              <Link to="/category/all" className="font-label text-xs text-foreground-500 hover:text-primary-600">
                更多
              </Link>
            </div>
            <ol className="mt-2 divide-y divide-background-200">
              {hotList.map((item, index) => (
                <li key={item.id} className="flex items-start gap-3 py-3">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                      index === 0
                        ? 'bg-primary-500 text-background-50'
                        : index < 3
                          ? 'bg-accent-500 text-background-50'
                          : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <Link
                      to={`/article/${item.id}`}
                      className="line-clamp-2 font-body text-sm leading-snug text-foreground-800 transition-colors hover:text-primary-600"
                    >
                      {item.title}
                    </Link>
                    <span className="mt-1 block font-label text-xs text-foreground-500">
                      {formatViews(item.views)} 次围观
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}